import React, {useContext, useEffect, useState} from "react";
import StyleContext from "../../contexts/StyleContext";
import {useAuth} from "../../contexts/AuthContext";
import {useSettings} from "../../contexts/SettingsContext";
import {adminGetSettings, adminUpdateSettings} from "../../services/api";
import Loader from "../../components/loader/Loader";

const SECTIONS = [
  {key: "sections.greeting",    label: "Greeting (hero)",     desc: "Top intro / hero block"},
  {key: "sections.skills",      label: "Skills",              desc: "‘What I do’ section"},
  {key: "sections.techStack",   label: "Tech Stack",          desc: "Proficiency / progress bars"},
  {key: "sections.education",   label: "Education",           desc: "Schools & qualifications"},
  {key: "sections.experience",  label: "Work Experience",     desc: "Employment history"},
  {key: "sections.projects",    label: "Projects",            desc: "Featured projects"},
  {key: "sections.resume",      label: "Resume nav link",     desc: "Show the Resume entry in the top navigation"},
  {key: "sections.resumePdf",   label: "Resume — PDF download", desc: "Allow public visitors to download the resume as PDF"},
  {key: "sections.contact",     label: "Contact section",     desc: "Hide to remove the entire Contact section"},
  {key: "sections.contactForm", label: "Contact form (inbox)", desc: "ON = interactive form. OFF = static phone/email only."},
];

const SettingsPanel = () => {
  const {isDark} = useContext(StyleContext);
  const {token} = useAuth();
  const {refresh} = useSettings();
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [savedAt, setSavedAt] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await adminGetSettings(token);
        setValues(res.settings || {});
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  const toggle = key => {
    setValues(v => ({...v, [key]: !v[key]}));
  };

  const save = async () => {
    setSaving(true);
    setError("");
    try {
      await adminUpdateSettings(values, token);
      setSavedAt(new Date());
      refresh(); // tell the public site to pick up the new values
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Loader inline label="Loading settings" />;

  return (
    <div className={`settings ${isDark ? "dark" : ""}`}>
      <div className="settings__header">
        <div>
          <h2>Site sections</h2>
          <p className="admin__lead" style={{margin: 0}}>
            Toggle which portfolio sections appear publicly. Changes apply immediately after saving.
          </p>
        </div>
        <div className="settings__save">
          {savedAt && <span className="settings__saved">Saved · {savedAt.toLocaleTimeString()}</span>}
          <button onClick={save} disabled={saving}>
            {saving ? "Saving…" : "Save changes"}
          </button>
        </div>
      </div>

      {error && <p className="modal__error">{error}</p>}

      <div className="settings__grid">
        {SECTIONS.map(s => {
          const on = !!values[s.key];
          return (
            <div key={s.key} className="settings__row">
              <div>
                <div className="settings__label">{s.label}</div>
                <div className="settings__desc">{s.desc}</div>
              </div>
              <label className="rd-switch" aria-label={`Toggle ${s.label}`}>
                <input type="checkbox" checked={on} onChange={() => toggle(s.key)} />
                <span className="rd-switch__slider" />
                <span className="rd-switch__state">{on ? "ON" : "OFF"}</span>
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SettingsPanel;
